import { Enum } from "../../types/types";

export const ForgotPasswordPageLocators = Enum(
  "forgotPassword_input_email",
  "forgotPassword_input_code",
  "forgotPassword_button_submit",
  "forgotPassword_button_submit_verification_code",
  "forgotPassword_button_resend_verification_code",
  "resetPassword_input_password",
  "resetPassword_input_confirm_password",
  "resetPassword_button_submit",
  "resetPassword_button_login"
);
